import PropTypes from 'prop-types';

// *** components *** //
import StyleAuxiliary from '../../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import { Checkbox } from '@upmc/ims.component-library';
import { Subtitle2 } from '../../../../components/UI/MDC/Typography/Typography';

// *** utils *** //
import useFormInput from '../../../../utils/hooks/useFormInput';
import classes from './StaffAccessAgreement.module.scss';

const copy = {
	exhibitA: 'EXHIBIT "A"',
	confidentialityAgreement:
		'UPMC CONFIDENTIALITY AGREEMENT FOR THIRD PARTY USERS ACCESSING UPMC INFORMATION SYSTEMS',
	listHeader: 'I understand and agree that:',
	listItems: [
		'UPMC considers identifiable patient health information of UPMC patients and other UPMC information contained within UPMC computer systems to be confidential (“UPMC Confidential Information”). I will keep all UPMC Confidential Information confidential.',
		'I have read and agree to comply with the terms of the agreement titled “UPMC Third Party Computer System Access Agreement” (“TPA Agreement”) that was entered into by my employer/educational institution and UPMC.',
		'I will be provided with a username and password to UPMC computer systems (“Account Information”), so that I may access UPMC computer systems.',
		'I will use UPMC computer systems only to access such information as is minimally necessary for the purposes outlined in the TPA Agreement. I will not attempt to access information for any other purpose.',
		'I will not share or disclose my Account Information.',
		'If my access to UPMC computer systems is no longer required, I will immediately inform my employer/educational institution.',
		'My access to UPMC computer systems may be revoked if I do not access UPMC computer systems for a period of ninety (90) days.',
		'At a minimum, my need to access UPMC computer systems will be reviewed on an annual basis.',
		'If I become aware that my username and password have been compromised, I will inform the UPMC ISD Information Security Group immediately in writing at InformationSecurity@upmc.edu.',
		'I understand that UPMC maintains an audit trail of my access to UPMC Confidential Information. This audit trail may be reviewed at any time to determine if my access to UPMC Confidential Information was appropriate.',
		'I understand that if I violate these terms, my access may be revoked by UPMC at its sole discretion. UPMC also reserve the right to notify affected patient, government authorities and others as required by law of any inappropriate access or violation of these terms.',
	],
	version: 'Version - 02012021',
	checkboxText: 'I agree to the terms and conditions stated above.',
};

const StaffAccessAgreement = props => {
	const { field, meta } = useFormInput(props);

	// *** ui *** //
	const renderHeaders = () => (
		<StyleAuxiliary classes={classes['header']}>
			<div className={classes['header__confidentiality']}>
				<p>
					<strong>{copy.exhibitA}</strong>
					<br />
					<strong>{copy.confidentialityAgreement}</strong>
				</p>
			</div>
		</StyleAuxiliary>
	);

	const renderAgreementList = () => (
		<>
			<div className={classes['header__list']}>{copy.listHeader}</div>
			<ol>
				{copy.listItems.map((item, idx) => (
					<li key={idx}>{item}</li>
				))}
			</ol>
			{copy.version}
		</>
	);

	const renderCheckbox = () => (
		<StyleAuxiliary className={classes['checkbox__container']}>
			<Checkbox {...field} label={copy.checkboxText} />
		</StyleAuxiliary>
	);

	const renderValidationMessage = () => (
		<Subtitle2 className={classes['invalid']}>{meta.error}</Subtitle2>
	);

	return (
		<>
			{renderHeaders()}
			{renderAgreementList()}
			{renderCheckbox()}
			{meta && meta.touched && meta.error && renderValidationMessage()}
		</>
	);
};

StaffAccessAgreement.propTypes = {
	name: PropTypes.string,
};

export default StaffAccessAgreement;
